export function getAsUrl(val: string, insert: number | string): string {
  return val?.replace(/\$/, String(insert));
}
